import { ReactNode, useMemo } from 'react';
import styles from './FiltersLayoutForSearch.css';
import { Filter } from './components/Filter';
import { TFilter } from 'shared/types/filters';

interface IFilter {
  id: TFilter;
  component: ReactNode;
}

interface IFiltersLayoutForSearchProps {
  filters: IFilter[];
  applyButton: React.ReactNode;
  searchButton: React.ReactNode;
  tags: React.ReactNode;
}

export const FiltersLayoutForSearch: React.FC<IFiltersLayoutForSearchProps> = ({
  filters,
  applyButton,
  tags,
  searchButton,
}) => {
  const { mainFilters, advancedFilters } = useMemo(
    () => ({
      mainFilters: filters.filter(({ id }) => id !== 'advancedFilters'),
      advancedFilters: filters.find(({ id }) => id === 'advancedFilters')?.component,
    }),
    [filters],
  );

  return (
    <div className={styles['container']}>
      <div className={styles['layout']}>
        <div className={styles['filters']}>
          {mainFilters.map(({ id, component }) => (
            <Filter key={`filter_${id}`} dataTestId={id}>
              {component}
            </Filter>
          ))}
          <Filter className={styles['geo']}>{advancedFilters}</Filter>

          <div className={styles['button']}>{applyButton}</div>

          <div className={styles['button']}>{searchButton}</div>
        </div>
      </div>
      <div className={styles['tags']}>{tags}</div>
    </div>
  );
};
